import type { ColorPreset } from './appearanceColorPresetTypes'

export const LIGHT_COLOR_PRESETS: ColorPreset[] = [
  {
    id: 'light-blue',
    name: 'Sky Blue',
    description: 'Corporativo claro e moderno',
    swatch: ['#2563eb', '#ffffff', '#f0f7ff', '#111827', '#6b7280'],
    colors: {
      mode: 'light' as const,
      brandPrimary: '#2563eb',
      brandPrimaryHover: '#1d4ed8',
      brandPrimaryMuted: '#dbeafe',
      brandSecondary: '#10b981',
      brandSecondaryHover: '#059669',
      fontColorH1: '#0f172a',
      fontColorH2: '#1e293b',
      fontColorH3: '#334155',
      fontColorBody: '#475569',
      fontColorMuted: '#64748b',
      fontColorLabel: '#94a3b8',
      bgDark: '#e2e8f0',
      bgMain: '#f1f5f9',
      bgHeader: '#ffffff',
      textHeader: '#0f172a',
      bgSidebar: '#f8fafc',
      textSidebar: '#1e293b',
      bgCard: '#ffffff',
      textPrimary: '#0f172a',
      textSecondary: '#1e293b',
      textMuted: '#64748b',
    },
  },
  {
    id: 'light-green',
    name: 'Agrada Light',
    description: 'Verde fresco e produtivo',
    swatch: ['#16a34a', '#ffffff', '#f0fdf4', '#14532d', '#6b7280'],
    colors: {
      mode: 'light' as const,
      brandPrimary: '#16a34a',
      brandPrimaryHover: '#15803d',
      brandPrimaryMuted: '#dcfce7',
      brandSecondary: '#22c55e',
      brandSecondaryHover: '#16a34a',
      fontColorH1: '#14532d',
      fontColorH2: '#166534',
      fontColorH3: '#15803d',
      fontColorBody: '#374151',
      fontColorMuted: '#6b7280',
      fontColorLabel: '#9ca3af',
      bgDark: '#f0fdf4',
      bgMain: '#f7fdf9',
      bgHeader: '#ffffff',
      textHeader: '#14532d',
      bgSidebar: '#ffffff',
      textSidebar: '#166534',
      bgCard: '#ffffff',
      textPrimary: '#14532d',
      textSecondary: '#166534',
      textMuted: '#6b7280',
    },
  },
  {
    id: 'light-purple',
    name: 'Lavender',
    description: 'Suave e criativo',
    swatch: ['#7c3aed', '#ffffff', '#f5f3ff', '#2e1065', '#8b5cf6'],
    colors: {
      mode: 'light' as const,
      brandPrimary: '#7c3aed',
      brandPrimaryHover: '#6d28d9',
      brandPrimaryMuted: '#ede9fe',
      brandSecondary: '#a855f7',
      brandSecondaryHover: '#9333ea',
      fontColorH1: '#1e1b4b',
      fontColorH2: '#2e1065',
      fontColorH3: '#4c1d95',
      fontColorBody: '#374151',
      fontColorMuted: '#6b7280',
      fontColorLabel: '#9ca3af',
      bgDark: '#f5f3ff',
      bgMain: '#faf9ff',
      bgHeader: '#ffffff',
      textHeader: '#1e1b4b',
      bgSidebar: '#faf9ff',
      textSidebar: '#2e1065',
      bgCard: '#ffffff',
      textPrimary: '#1e1b4b',
      textSecondary: '#2e1065',
      textMuted: '#6b7280',
    },
  },
  {
    id: 'light-orange',
    name: 'Sunset',
    description: 'Energia e calor humano',
    swatch: ['#ea580c', '#ffffff', '#fff7ed', '#431407', '#fdba74'],
    colors: {
      mode: 'light' as const,
      brandPrimary: '#ea580c',
      brandPrimaryHover: '#c2410c',
      brandPrimaryMuted: '#ffedd5',
      brandSecondary: '#f97316',
      brandSecondaryHover: '#ea580c',
      fontColorH1: '#431407',
      fontColorH2: '#7c2d12',
      fontColorH3: '#9a3412',
      fontColorBody: '#374151',
      fontColorMuted: '#6b7280',
      fontColorLabel: '#9ca3af',
      bgDark: '#fff7ed',
      bgMain: '#fffbf7',
      bgHeader: '#ffffff',
      textHeader: '#431407',
      bgSidebar: '#ffffff',
      textSidebar: '#7c2d12',
      bgCard: '#ffffff',
      textPrimary: '#431407',
      textSecondary: '#7c2d12',
      textMuted: '#6b7280',
    },
  },
  {
    id: 'light-gray',
    name: 'Slate Clean',
    description: 'Minimalista e foco máximo',
    swatch: ['#334155', '#ffffff', '#f8fafc', '#0f172a', '#94a3b8'],
    colors: {
      mode: 'light' as const,
      brandPrimary: '#334155',
      brandPrimaryHover: '#1e293b',
      brandPrimaryMuted: '#e2e8f0',
      brandSecondary: '#64748b',
      brandSecondaryHover: '#475569',
      fontColorH1: '#0f172a',
      fontColorH2: '#1e293b',
      fontColorH3: '#334155',
      fontColorBody: '#475569',
      fontColorMuted: '#64748b',
      fontColorLabel: '#94a3b8',
      bgDark: '#e2e8f0',
      bgMain: '#f8fafc',
      bgHeader: '#ffffff',
      textHeader: '#0f172a',
      bgSidebar: '#f1f5f9',
      textSidebar: '#1e293b',
      bgCard: '#ffffff',
      textPrimary: '#0f172a',
      textSecondary: '#1e293b',
      textMuted: '#64748b',
    },
  },
]
